import { Chip, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { IconWithLabel, TableColumn } from '../../../../ui';
import { ADMIN_USER_TYPE_COLOR_MAP } from '../constants';
import type { IUserRow } from '../interfaces';
import { formatDashboardDate } from './formatDashboardDate';

export const getUserColumns = (onView?: (row: IUserRow) => void): TableColumn<IUserRow>[] => [
  {
    key: 'Name',
    label: 'User',
    width: '280px',
    align: 'left',
    render: (row: IUserRow) => (
      <IconWithLabel
        label={row.Name}
        subLabel={row.Email}
        avatarUrl={row['Profile Picture']}
        avatarName={row.Name}
        onClick={onView ? () => onView(row) : undefined}
        maxWidth={180}
      />
    ),
  },
  {
    key: 'User Type',
    label: 'User Type',
    width: '150px',
    align: 'left',
    render: (row: IUserRow) => {
      const value = row['User Type'];
      if (!value || value === '-') {
        return (
          <Typography variant="body2" color="text.disabled" align="left">
            —
          </Typography>
        );
      }
      return (
        <Chip
          label={value}
          size="small"
          color={ADMIN_USER_TYPE_COLOR_MAP[value] ?? 'default'}
          sx={{ fontWeight: 600, fontSize: '0.75rem' }}
        />
      );
    },
  },
  {
    key: 'Roles Assigned',
    label: 'Roles Assigned',
    width: '140px',
    align: 'left',
    render: (row: IUserRow) => (
      <Typography
        variant="body2"
        fontWeight={600}
        align="left"
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {String(row['Roles Assigned'] ?? '—')}
      </Typography>
    ),
  },
  {
    key: 'Assessments',
    label: 'Assessments',
    width: '140px',
    align: 'left',
    render: (row: IUserRow) => (
      <Typography
        variant="body2"
        fontWeight={600}
        align="left"
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {String(row.Assessments ?? '—')}
      </Typography>
    ),
  },
  {
    key: 'Job Applicants',
    label: 'Job Applicants',
    width: '140px',
    align: 'left',
    render: (row: IUserRow) => (
      <Typography
        variant="body2"
        fontWeight={600}
        align="left"
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {String(row['Job Applicants'] ?? '—')}
      </Typography>
    ),
  },
  {
    key: 'Last Login',
    label: 'Last Login',
    width: '180px',
    align: 'left',
    render: (row: IUserRow) => {
      const display = formatDashboardDate(row['Last Login']);
      return (
        <Tooltip title={display} arrow placement="top">
          <Typography variant="body2" noWrap align="left" sx={{ maxWidth: 180 }}>
            {display}
          </Typography>
        </Tooltip>
      );
    },
  },
];
